import { Button, Grid } from "@mui/material";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
/* eslint-disable react-hooks/exhaustive-deps */
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import InputNumber from "../../../../components/hookForms/inputNumber";
import InputText from "../../../../components/hookForms/textField";
import messages from "../../../../utils/messages";
import serviceMotivoMovimentacaoInstalacao from "../../../../services/serviceMotivoMovimentacaoInstalacao";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    data: {
        open: boolean;
        id: string;
        valorInjecaoFixa: string;
        valorInjecaoPercentual: string;
        descricao: string;
        tipo: string;
        tipoAlteracao: string;
        observacao: string;
    };
    onClose?: any;
}

export default function DialogEdit({ open, data, onClose, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);
    const [disablePercentual, setDisablePercentual] = useState(false);
    const [disableFixa, setDisableFixa] = useState(false);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
        // eslint-disable-next-line react-hooks/rules-of-hooks
    } = useForm({
        defaultValues: {
            valorInjecaoFixa: "",
            valorInjecaoPercentual: "",
            descricao: "",
            tipo: "",
            tipoAlteracao: "",
            observacao: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    useEffect(() => {
        if (+data.valorInjecaoFixa === 0) {
            setDisableFixa(true);
        } else {
            setDisableFixa(false);
        }

        if (+data.valorInjecaoPercentual === 0) {
            setDisablePercentual(true);
        } else {
            setDisablePercentual(false);
        }
    }, [data]);

    function onBlur(e: any) {
        if (e.target.value > 0 && e.target.name === "valorInjecaoFixa") {
            setDisablePercentual(true);
        } else {
            setDisablePercentual(false);
        }

        if (e.target.value > 0 && e.target.name === "valorInjecaoPercentual") {
            setDisableFixa(true);
        } else {
            setDisableFixa(false);
        }
    }

    const Validate = (values: any) => {
        if (values.tipo && values.tipo === "A") {
            if (!values.tipoAlteracao) {
                toast.error("Tipo alteração deve ser informado para Tipo igual a 'Alteração'");
                return false;
            }
            if (values.tipoAlteracao === "I" && !values.valorInjecaoFixa && !values.valorInjecaoPercentual) {
                toast.error(
                    "Valor injeção fixa OU Valor injeção percentual devem ser informados para tipo alteração igual a Injeção"
                );
                return false;
            }
        }
        return true;
    };

    const onSubmit = (values: any) => {
        const treatedValues = {
            ...values,
            rebalanceMotivoMovimentacaoInstalacaoID: values.id,
            ativo: "S",
            tipoAlteracao:
                values.tipo === "Inclusão" || values.tipo === "Exclusão"
                    ? ""
                    : values.tipoAlteracao === "Injeção"
                    ? "I"
                    : "C",
            tipo: values.tipo === "Inclusão" ? "I" : values.tipo === "Alteração" ? "A" : "E",
            valorInjecaoFixa:
                values.valorInjecaoFixa && values.tipoAlteracao !== "Cota"
                    ? Number(values.valorInjecaoFixa.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
            valorInjecaoPercentual:
                values.valorInjecaoPercentual && values.tipoAlteracao !== "Cota"
                    ? Number(values.valorInjecaoPercentual.replaceAll(".", "").replaceAll(",", "."))
                    : 0,
        };

        if (Validate(treatedValues)) {
            setDisable(true);

            serviceMotivoMovimentacaoInstalacao
                .update(treatedValues)
                .then((result) => {
                    if (result) {
                        toast.success(messages.updateSucess);
                        onClose(true);
                        onSuccess();
                        reset();
                    }
                })
                .catch((err) => {
                    toast.error(messages.updateError, err);
                })
                .finally(() => {
                    setDisable(false);
                });
        }
    };

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    onClose();
                }
            }}
            open={open}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>
                    Editar Motivo
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={4}>
                            <InputText name="descricao" label="Motivo" disabled control={control} error={errors} />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <InputText name="tipo" label="Tipo" disabled control={control} error={errors} />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <InputText
                                name="tipoAlteracao"
                                label="Tipo de alteraçao"
                                disabled
                                control={control}
                                error={errors}
                            />
                        </Grid>
                        {data.tipoAlteracao === "Injeção" && (
                            <>
                                <Grid item xs={12} md={6}>
                                    <InputNumber
                                        name="valorInjecaoFixa"
                                        label="Injecao fixa"
                                        onBlur={onBlur}
                                        control={control}
                                        error={errors}
                                        decimalScale={2}
                                        maxLength={16}
                                        disabled={disableFixa}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <InputNumber
                                        name="valorInjecaoPercentual"
                                        label="Injeção %"
                                        onBlur={onBlur}
                                        control={control}
                                        error={errors}
                                        decimalScale={2}
                                        maxLength={16}
                                        disabled={disablePercentual}
                                    />
                                </Grid>
                            </>
                        )}

                        <Grid item xs={12} md={12}>
                            <InputText name="observacao" label="Observação" control={control} error={errors} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                    <Button
                        onClick={onClose}
                        color="warning"
                        variant="contained"
                        style={{ width: "159px", height: "44px" }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                        disabled={isDisable}
                        style={{ width: "159px", height: "44px" }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}
